import { postStatusQuery, StatusQueryRequest } from '../../Services/serviceURL';

export type ConnectivityChartPoint = {
  date: string;
  communicationPercent: number;
  nonCommunicationPercent: number;
};

export function getConnectivityTimeRangeValue(selectedTimeRange: string): number {
  return selectedTimeRange === '7 days' ? 5 : 6;
}

export function mapConnectivityResponseToChartData(response: unknown): ConnectivityChartPoint[] {
  const responseData = response as {
    data?: { Data?: Array<{ data?: Array<{ timestamp: string; value: number }> }> };
  };
  const channelData = responseData?.data?.Data?.[0];
  if (!channelData?.data?.length) return [];

  return channelData.data.map((item) => {
    const dateStr = new Date(item.timestamp).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
    });
    const communicationPercent = Math.round(item.value);
    return {
      date: dateStr,
      communicationPercent,
      nonCommunicationPercent: 100 - communicationPercent,
    };
  });
}

export function buildConnectivityStatusRequest(
  assetId: string,
  timeRange: string,
  selectedTimeRange: string,
  getDateRange: (range: string) => { startTime: string; endTime: string }
): StatusQueryRequest {
  const { startTime, endTime } = getDateRange(timeRange);
  const timeRangeValue = getConnectivityTimeRangeValue(selectedTimeRange);

  const request: StatusQueryRequest = {
    assetId,
    channelIds: ['M13'],
    startTime,
    endTime,
    timeRange: timeRangeValue,
  };

  if (timeRangeValue === 6) {
    const customRange = getDateRange(selectedTimeRange);
    request.startTime = customRange.startTime;
    request.endTime = customRange.endTime;
  }

  return request;
}

export async function fetchConnectivityChartData(
  assetId: string,
  timeRange: string,
  selectedTimeRange: string,
  getDateRange: (range: string) => { startTime: string; endTime: string }
): Promise<ConnectivityChartPoint[]> {
  const request = buildConnectivityStatusRequest(assetId, timeRange, selectedTimeRange, getDateRange);
  const response = await postStatusQuery(request);
  return mapConnectivityResponseToChartData(response);
}
